@if (model.id) {
    <app-product-list-widget
        [productGroupId]="model.id"
        [autoFocusSearch]="false"
        [fillHeightList]="true"
        [noAddNew]="true"
        [noDelete]="true"
        [viewName]="'ProductGroupUsedProducts'"
        [dataTestId]="'product-group-used-products-list'"
    />
} @else {
    <p class="m-4 text-sm text-slate-600">{{ 'product-group.save-to-see-products' | translate }}</p>
}
